import VimeoPlayer from '@vimeo/player';
import { youtubePlayerFor } from './youtube-player';

export function isElementInViewport(id) {
  const el = document.getElementById(id);
  if (el) {
    const { top, bottom } = el.getBoundingClientRect();
    const vHeight =
      (window.innerHeight || document.documentElement.clientHeight) / 2;

    return (top > -100 || bottom > vHeight) && top < vHeight;
  }
  return false;
}

// Sample when function that will only run a function
// if the predicate is true.
/**
 *
 * @param {function} predicate - a predicate function that takes in argumetns and returns a boolean
 * @param {function} fn - a function to be called when the predicate evaluates to true
 * @returns {function} - a function that takes in arguments that will be passed through to the predicate and callback function
 */
export function when(predicate, fn) {
  return function conditional(...args) {
    if (predicate(...args)) {
      return fn(...args);
    }
  };
}

/**
 * hasClass - simple vanilla js helper to check if an element has a class
 *          - compatable with IE 11 using indexOf() rather than the includes() method
 *
 * @param  {HTMLElement} element ex. dom element for targeting
 * @param  {string} cls     the class to check against
 * @return {boolean}         returns true if class exists, false if not
 */

export function hasClass(element, cls) {
  if (!element) return false;

  return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
}

/**
 * const addClass - add class helper to element
 *
 * @param  {HTMLElement} elem  element
 * @param  {string} cls classes  ex. 'is-open'
 */

export function addClass(elem, cls) {
  elem.classList.add(cls);
}

/**
 * const removeClass - add class helper to element
 *
 * @param  {HTMLElement} elem  element
 * @param  {string} cls class  ex. 'is-open'
 */

export function removeClass(elem, cls) {
  elem.classList.remove(cls);
}

/**
 * Serialize all form data into a query string
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}   form The form to serialize
 * @return {String}      The serialized form data
 */
export function serialize(form) {
  // Setup our serialized data
  var serialized = [];
  // Loop through each field in the form
  for (var i = 0; i < form.elements.length; i++) {
    var field = form.elements[i];
    // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
    if (
      !field.name ||
      field.disabled ||
      field.type === 'file' ||
      field.type === 'reset' ||
      field.type === 'submit' ||
      field.type === 'button'
    )
      continue;
    // If a multi-select, get all selections
    if (field.type === 'select-multiple') {
      for (var n = 0; n < field.options.length; n++) {
        if (!field.options[n].selected) continue;
        serialized.push(
          encodeURIComponent(field.name) +
            '=' +
            encodeURIComponent(field.options[n].value)
        );
      }
    }
    // Convert field data to a query string
    else if (
      (field.type !== 'checkbox' && field.type !== 'radio') ||
      field.checked
    ) {
      serialized.push(
        encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
      );
    }
  }
  return serialized.join('&');
}

/**
 *
 * @param  {string} swiperId video carousel id
 */
export function videoPlayerHandler(swiperId) {
  const embeddedVideos = document.querySelectorAll(
    `${swiperId} .swiper-slide:not(.swiper-slide-duplicate) iframe`
  );
  embeddedVideos.forEach(embeddedVideo => {
    const videoSrc = embeddedVideo.getAttribute('src');
    if (videoSrc && videoSrc.indexOf('vimeo') >= 0) {
      new VimeoPlayer(embeddedVideo).pause();
    } else if (videoSrc && videoSrc.indexOf('youtube') >= 0) {
      youtubePlayerFor(embeddedVideo).then(player => player.pauseVideo());
    }
  });
}

/**
 * const disableScroll - disable scrolling on body for modals
 *
 * @param {bool}
 */

export function disableScroll(bool) {
  if (bool) {
    document.body.style.top = `-${window.scrollY}px`;
    addClass(document.body, 'no-scroll');
    addClass(document.documentElement, 'no-scroll');
  } else {
    const scrollY = document.body.style.top;
    removeClass(document.body, 'no-scroll');
    removeClass(document.documentElement, 'no-scroll');
    document.body.style.top = '';
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
  }
}

/**
 * const goToCurrentScroll - add overflow hidden on body for modals
 *
 * @param {bool}
 */

export function goToCurrentScroll(bool) {
  if (bool) {
    document.body.style.top = `-${window.scrollY}px`;
    document.body.style.position = 'fixed';
  } else {
    const scrollY = document.body.style.top;
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
  }
}

/**
 *
 * @param {Object} obj
 * @param {Array} keys
 */
export function objectHasKeysDefined(obj, keys) {
  const ret = keys.filter(val => obj.hasOwnProperty(val));
  console.log(ret);
  return ret.length == keys.length;
}

/**
 *
 * @param {String} str
 * @returns {String}
 */
export function htmlEntities(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/\*/g, '&#42;')
    .replace(/\+/g, '&#43;');
}

/**
 *
 * @param {Array} array
 * @returns {Array}
 */
export function shuffle(array) {
  var currentIndex = array.length,
    temporaryValue,
    randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}

export function getWindowHeight() {
  if (document.compatMode === 'BackCompat') {
    return document.body.clientHeight;
  } else {
    return document.documentElement.clientHeight;
  }
}

export const getPageVariable = variableName => {
  const variableValueContainer = document.querySelector(
    `ul#js-page-variables > li[rel="${variableName}"]`
  );

  if (!variableValueContainer) return;

  return JSON.parse(variableValueContainer.innerHTML);
};

export const analyticsPageName = () => getPageVariable('analyticsPageName');

export const isDealerPage = () => getPageVariable('isDealerPage?');
export const isOemPage = () => getPageVariable('isOemPage?');

export const openModalWhenReady = modal => {
  const openModalLink = document.querySelector(
    `[data-micromodal-trigger="${modal.id}"]`
  );

  if (openModalLink) {
    window.addEventListener('DOMContentLoaded', () => {
      openModalLink.dispatchEvent(new MouseEvent('click'));
    });
  }
};

export const namespacedObject = (namespaces, object = {}) => {
  if (!namespaces) return object;

  if (!Array.isArray(namespaces)) namespaces = [namespaces];

  for (const namespace of namespaces) {
    object = object[namespace] = object[namespace] || {};
  }

  return object;
};

export const waitForElement = async selector => {
  while (!document.querySelector(selector)) {
    await new Promise(resolve => requestAnimationFrame(resolve));
  }
  return document.querySelector(selector);
};

export const useAddToCartModal = () => {
  const modalEl = document.getElementById('add-to-cart-modal');
  const confirmationEl = document.getElementById('add-to-cart-confirmation');
  const closeButtonEl = document.getElementById(
    'add-to-cart-confirmation__close'
  );

  if (!!modalEl) modalEl.style.display = 'inherit';
  if (!!confirmationEl) confirmationEl.style.display = 'none';
  if (!!closeButtonEl) closeButtonEl.style.display = 'none';
};

export const useCartConfirmationModal = () => {
  const modalEl = document.getElementById('add-to-cart-modal');
  const confirmationEl = document.getElementById('add-to-cart-confirmation');
  const closeButtonEl = document.getElementById(
    'add-to-cart-confirmation__close'
  );

  if (!!modalEl) modalEl.style.display = 'none';
  if (!!confirmationEl) confirmationEl.style.display = 'inherit';
  if (!!closeButtonEl) closeButtonEl.style.display = 'inherit';
};

export const externalNgLoader = async () => {
  if (window.externalNgLoaded) {
    return Promise.resolve();
  }

  if (window.externalNgLoading && window.externalNgReadyPromise) {
    return window.externalNgReadyPromise;
  }

  const versionContainer = document.querySelector('[data-external-ng-version]');
  const versionMetaTag = document.querySelector(
    'meta[name="external-ng-version"]'
  );
  const version =
    versionContainer?.dataset.externalNgVersion || versionMetaTag?.content;
  const ngappsWebsiteUrl = window.NGAPPS_WEBSITE_URL;

  if (!version) {
    logErrorToSentry(new Error('Unable to determine external NG version'));
    return Promise.reject(new Error('Unable to determine external NG version'));
  }

  if (!ngappsWebsiteUrl) {
    logErrorToSentry(new Error('Unable to determine NGAPPS website URL'));
    return Promise.reject(new Error('Unable to determine NGAPPS website URL'));
  }

  window.externalNgLoading = true;
  window.externalNgReadyPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.defer = true;
    script.src = `${ngappsWebsiteUrl}/external/main.js?_=${version}`;
    script.onload = () => {
      window.externalNgLoaded = true;
      window.externalNgLoading = false;
      resolve();
    };
    script.onerror = error => {
      window.externalNgLoading = false;
      window.externalNgReadyPromise = null;
      reject(error);
    };
    document.body.appendChild(script);
  }).catch(error => {
    logErrorToSentry(error);
    throw error;
  });

  return window.externalNgReadyPromise;
};

export const logErrorToSentry = error => {
  console.error('Error:', error);
  if (!window.Sentry) return;
  let toCapture = error;
  if (!(error instanceof Error)) {
    if (typeof Event !== 'undefined' && error instanceof Event) {
      const target = error.target || error.currentTarget;
      const src = target && (target.src || target.href);
      const tag = target && target.tagName;
      toCapture = new Error(
        `Non-Error captured: ${error.type} event` +
          (tag ? ` on <${String(tag).toLowerCase()}>` : '') +
          (src ? ` (${src})` : '')
      );
    } else {
      try {
        toCapture = new Error(
          typeof error === 'string' ? error : JSON.stringify(error)
        );
      } catch (_) {
        toCapture = new Error('Non-Error value captured');
      }
    }
  }
  Sentry.captureException(toCapture);
};
